import { ArticleHeroWrapper } from '@components/marketing-website/ArticleHero/styles'
import { InlineWozCheckBoxWrapper } from '@components/marketing-website/InlineWozCheckBox/styles'
import styled from '@emotion/styled'

export const AddressWrapper = styled.div(({ theme }) => ({
  background: theme.colors.N20,
  borderRadius: 4,
  padding: 24,
  marginBottom: 24,
  '& p': {
    marginBottom: '0 !important',
  },
}))

export const StyledH2 = styled.h2(({ theme }) => ({
  marginTop: 16,
  [theme.breakpoint.up('md')]: {
    marginTop: 24,
  },
}))

export const Main = styled.main(({ theme }) => ({
  maxWidth: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  // overflow: "hidden",
  [theme.breakpoint.down('md')]: {
    width: '100%',

    [`${ArticleHeroWrapper}`]: {
      height: 80,
      svg: {
        display: 'none'
      },
      h1: {
        fontSize: 18,
        padding: '0 16px'
      }
    }
  },
}))

export const PageWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  maxWidth: 1045,
  margin: '80px auto 0',
  '& > div:first-child': {
    flex: '1 0 355px',
    maxWidth: 355
  },
  [theme.breakpoint.up('md')]: {
    '& > div:first-child': {
      padding: '0 8px',
    },
  },
  [theme.breakpoint.down('xl')]: {
    marginTop: 40,
    '& > div:first-child': {
      display: 'none',
    },
  },
}))

export const SectionWrapper = styled('div', {
  shouldForwardProp: prop => prop !== 'hasSidebar',
})<{ hasSidebar?: boolean }>(({ theme, hasSidebar }) => ({
  position: 'relative',
  maxWidth: 780,
  width: '100%',
  margin: '0 auto',
  paddingRight: 8,
  marginTop: hasSidebar ? 0 : 80,
  [theme.breakpoint.down('md')]: {
    marginTop: hasSidebar ? 0 : 40,
    paddingLeft: 16,
    paddingRight: 16,
    h2: {
      fontSize:'18px!important',
      marginBottom: '16px!important',
    },
    'h3, h4': {
      fontSize: '16px!important',
      marginBottom: '16px!important',
    },
    [`${InlineWozCheckBoxWrapper}`]: {
      display: 'none!important'
    }
  },
  '& > div:first-child[class=*]': {
    marginTop: 0,
  },
}))

export const BreadcrumbWrapper = styled.ol(({ theme }) => ({
  display: 'inline-block',
  listStyle: 'none',
  padding: 0,
  
  position: 'absolute',
  top: -36,
  margin: 0,

  [theme.breakpoint.down('xl')]: {
    position: 'relative',
    marginTop: 10,
    height: 0
  },

  '& > li': {
    float: 'left',
    fontSize: theme.fontSizes.desktop.small,

    '& > a': {
      color: theme.colors.B300
    },
    '& > span': {
      margin: '0 5px'
    }
  }
}))

export const Footnote = styled.div(({ theme }) => ({
  fontStyle: 'italic',
  maxWidth: 500,
  marginTop: 16,
  marginBottom: 64,
  lineHeight: 1.5,
  fontSize: 14,

  [theme.breakpoint.down('md')]: {
    marginTop: -16,
    marginBottom: 16,
  }
}))

export const Savings = styled.div(({ theme }) => ({
  marginTop: -44,
  marginBottom: 64,

  [theme.breakpoint.down('md')]: {
    marginTop: -14,
    marginBottom: 34,
  },
}))